import { AnimatePresence, motion } from "framer-motion";

export default function ConfirmModal({
  open,
  title,
  message,
  icon: Icon,
  iconContainerClassName = "bg-red-100 text-red-500",
  confirmText = "Confirmar",
  confirmClassName = "bg-med-primary hover:bg-med-primary/90",
  onCancel,
  onConfirm,
  loading = false,
}) {
  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
          <motion.div
            initial={{
              opacity: 0,
              scale: 0.95,
              y: 10,
            }}
            animate={{
              opacity: 1,
              scale: 1,
              y: 0,
            }}
            exit={{
              opacity: 0,
              scale: 0.95,
              y: 10,
            }}
            className="w-full max-w-lg rounded-3xl border border-med-border bg-white p-8 shadow-2xl"
          >
            <div className="flex items-start gap-4">
              <div
                className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl ${iconContainerClassName}`}
              >
                {Icon && <Icon size={28} weight="duotone" />}
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-700">{title}</h3>

                <p className="mt-2 text-gray-600">{message}</p>
              </div>
            </div>

            <div className="mt-8 flex justify-end gap-3">
              <button
                type="button"
                onClick={onCancel}
                disabled={loading}
                className="rounded-2xl border border-med-border px-5 py-2.5 text-sm font-semibold text-gray-700 transition-colors hover:bg-med-surface disabled:cursor-not-allowed disabled:opacity-50"
              >
                Cancelar
              </button>

              <button
                type="button"
                onClick={onConfirm}
                disabled={loading}
                className={`rounded-2xl px-5 py-2.5 text-sm font-semibold text-white transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${confirmClassName}`}
              >
                {loading ? "Procesando..." : confirmText}
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
